import React from 'react';
import { Chip } from '@mui/material';

export interface ReputationPillProps {
  uiScore: number;
  level: string; // e.g., 'Strong Uplift', 'Mild Uplift', 'Neutral', 'Mild Damage', 'Severe Damage'
  color?: string; // optional explicit color from backend if available
}

function getPillColors(level: string, fallback?: string) {
  // Match the top-level idea styling semantics
  switch (true) {
    case /Strong Uplift/i.test(level):
      return { bg: '#06D6A020', fg: '#06D6A0' };
    case /Mild Uplift/i.test(level):
      return { bg: '#80D6A020', fg: '#1FAD84' };
    case /Neutral/i.test(level):
      return { bg: '#FFD16620', fg: '#C48F00' };
    case /Mild Damage/i.test(level):
      return { bg: '#FF9A6620', fg: '#FF9A66' };
    case /Severe Damage/i.test(level):
      return { bg: '#FF6B6B20', fg: '#FF6B6B' };
    default:
      return { bg: (fallback ? fallback + '20' : '#9CA3AF20'), fg: fallback || '#9CA3AF' };
  }
}

const ReputationPill: React.FC<ReputationPillProps> = ({ uiScore, level, color }) => {
  const colors = getPillColors(level, color);
  return (
    <Chip
      label={`${Math.round(uiScore)} • ${level}`}
      sx={{
        backgroundColor: colors.bg,
        color: colors.fg,
        fontWeight: 600,
        height: '32px',
        fontSize: '0.875rem',
        border: '1px solid',
        borderColor: colors.fg,
        px: 2,
        py: 0.5
      }}
      size="small"
    />
  );
};

export default ReputationPill;


